import { create } from 'zustand';

const state = { brand: [], product: [], agg: [], dc: [] };

export const useFilter = create((set) => ({
    ...state,
    page: 1,
    limit: 10,
    setFilter: (newState) => set((state) => ({ ...state, ...newState })),
    onClearFilter: () =>
        set(() => ({
            ...state,
        })),
    resetFilter: () => set(() => ({ ...state })),
}));
